/**
 * UX Sprint 2 — Contextual assistant hint line shown above stage content.
 *
 * Tiny, friendly, single-sentence helper that surfaces under the stage
 * hero: "Next recommended step" / "Missing input" / "Open More Tools…".
 */
import { Lightbulb } from "lucide-react";

export default function AssistantHint({ text, tone = "default", testid = "assistant-hint" }) {
    if (!text) return null;
    const cls =
        tone === "warning" ? "text-amber-200 border-amber-500/30 bg-amber-500/5" :
        tone === "ready"   ? "text-emerald-200 border-emerald-500/30 bg-emerald-500/5" :
        tone === "missing" ? "text-sky-200 border-sky-500/30 bg-sky-500/5" :
                             "text-zinc-300 border-zinc-800 bg-zinc-950";

    return (
        <div
            data-testid={testid}
            className={`inline-flex items-start gap-2 px-3 py-2 border rounded-sm text-xs ${cls}`}
        >
            <Lightbulb className="w-3.5 h-3.5 shrink-0 mt-0.5" />
            <span>{text}</span>
        </div>
    );
}
